import Helper from "@/services/Helper"

export default {
    status: {
        isPublished: (item) => {
            return item["status"] === "published"
        },
        isScheduled: (item) => {
            return item["status"] === "scheduled"
        },
        isDeleted: (item) => {
            return item["status"] === "deleted"
        },
        isScheduledRemoved: (item) => {
            return Helper.isString(item["scheduled_removed"])
        },
        isPrePublished: (item) => {
            return item["status"] === "prePublished"
        },
        isPreDeleted: (item) => {
            return item["status"] === "preDeleted"
        },
        isCanceled: (item) => {
            return item["status"] === "canceled"
        },
        isDraft: (item) => {
            return item["status"] === "draft"
        },
    },
    getId: (item) => {
        return item["id"]
    },
    getCreatedAt: (item) => {
        return item["created_at"]
    },
    getRemovedAt: (item) => {
        return item["removed_at"]
    },
    getScheduledPublished: (item) => {
        return item["scheduled_published"]
    },
    getScheduledRemoved: (item) => {
        return item["scheduled_removed"]
    },
    getPublishedAt: (item) => {
        return item["published_at"]
    },
    getChannelId: (item) => {
        return item["channel_id"]
    },
    getTypeCommerce: (item) => {
        return item["type_commerce"]
    },
    getHasVideo: (item) => {
        return item["has_video"]
    },
    getStatus: (item) => {
        return item["status"]
    },
    getCntComments: (item) => {
        return item["cnt_comments"]
    },
    imagePosition: {
        isTop: (item) => {
            return item["image_position"] === 1
        },
        isBottom: (item) => {
            return item["image_position"] === 2
        },
        isNone: (item) => {
            return item["image_position"] === null
        },
    },
    hasImage: (item) => {
        let images = item?.images

        if (!images) {
            return false
        }
        
        return Object.entries(item.images).some(([key]) => {
            return (item.images?.[key]?.host !== undefined && item.images?.[key]?.host !== null) &&
                (item.images?.[key]?.name !== undefined || item.images?.[key]?.name !== null)
        })
    },
    getImages: (item) => {
        let images = item?.images

        if (!images) {
            return []
        }

        return item.images
    },
    getFirstImage: (item) => {
        return {
            host: item.images?.[0]?.host,
            name: item.images?.[0]?.name,
        }
    },
    getTypeVisibility: (item) => {
        return item["type_visibility"]
    },
    getNewPrice: (item) => {
        return item["price"]["new"]
    },
    getOldPrice: (item) => {
        return item["price"]["old"]
    },
    getTimeActionStart: (item) => {
        return item["time_action"]["start"]
    },
    getTimeActionEnd: (item) => {
        return item["time_action"]["end"]
    },
    getPromocode: (item) => {
        return item["promocode"]
    },
    getPromocodeApi: (item) => {
        return item["promocode_api"]
    },
    getCategoryName: (item) => {
        return item["category_name"]
    },
    getShopName: (item) => {
        return item["shop"]["name"]
    },
    getShopImageHost: (item) => {
        return item["shop"]["image_host"]
    },
    getShopImageName: (item) => {
        return item["shop"]["image_name"]
    },
    getTypeId: (item) => {
        return item["type_id"]
    },
    getTitle: (item) => {
        return item["title"]
    },
    getActivateLink: (item) => {
        return item["activate_link"]
    },
    getCustomLink: (item) => {
        return item["custom_link"]
    },
    getIsModerate: (item) => {
        return item["is_moderate"]
    },
    getSaleTypeId: (item) => {
        return item["sale_type_id"]
    },
    getSaleTypeValue: (item) => {
        return item["sale_type_value"]
    },
}
